// Click-through detail for one squad member.
import { ArrowLeft } from "lucide-react";
import SquadAvatar, { STATUS } from "./SquadAvatar";
import { clock, dur, since } from "./squadUtils";

function Row({ k, v, testid }) {
  return (
    <div className="flex justify-between gap-3 py-1.5 border-b border-white/[0.04] text-[12.5px]">
      <span className="text-slate-400">{k}</span><span className="text-white text-right" data-testid={testid}>{v}</span>
    </div>
  );
}

export default function SquadMemberDetail({ m, onBack }) {
  const s = STATUS[m.status];
  const statusText = m.status === "offline" && m.disconnected ? "Offline (disconnected)" : s.label;
  return (
    <div className="p-4" data-testid={`squad-detail-${m.id}`}>
      <button type="button" onClick={onBack} className="text-[11px] text-slate-400 hover:text-white inline-flex items-center gap-1 mb-3" data-testid="squad-detail-back">
        <ArrowLeft className="w-3 h-3" /> All squad
      </button>
      <div className="flex items-center gap-3 mb-3">
        <SquadAvatar name={m.name} url={m.avatar_url} status={m.status} size={52} />
        <div className="min-w-0">
          <div className="text-[15px] font-semibold text-white truncate">{m.name}</div>
          {m.title && <div className="text-[11px] text-slate-400 truncate">{m.title}</div>}
          <div className={`text-[12px] font-medium ${s.text}`} data-testid="squad-detail-status">{statusText}{m.reason ? ` · ${m.reason}` : ""}</div>
        </div>
      </div>
      <Row k={m.status === "offline" ? "Offline since" : `${s.label} for`} v={m.status === "offline" ? clock(m.since) : since(m.since)} testid="squad-detail-since" />
      <Row k="Last activity" v={m.last_interaction ? `${clock(m.last_interaction)} (${since(m.last_interaction)} ago)` : "—"} testid="squad-detail-last" />
      <Row k="Session started" v={clock(m.session_started)} testid="squad-detail-session" />
      <Row k="Breaks today" v={dur(m.brb_today_s)} testid="squad-detail-brb-today" />
    </div>
  );
}
